export default __webpack_public_path__ + "static/media/programs-icon.ca2c903b.svg";